import { useContext, useEffect, useState } from 'react';
import CompleteSignup from '../CompleteSignup';
import { useFormik } from 'formik';
import { signUpAgent } from '@services/Api';
import { UserContext } from '@context/createContext';
import ToastError from '../../toast/ToastError';
import { getCookie, setCookie, validateNationalID } from '@helper/functions';
import ToastSuccess from '../../toast/ToastSuccess';
import InputText from '@/core/Input/InputText';
import InputNumber from '@/core/Input/InputNumber';
import { LoaderBtn } from '../../loading/Loader';

export default function SignupRealestate() {
  const [signUp, setSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState(null); // Store the cookie value in state
  const { refetch } = useContext(UserContext);

  useEffect(() => {
    const fetchCookie = async () => {
      const cookieId = await getCookie('id');
      setId(cookieId);
    };
    fetchCookie();
  }, []);

  const formikSignUpAgent = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      nationalID: '',
      // username: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.firstName.trim()) {
        errors.firstName = 'نام را وارد کنید';
      }
      if (!values.lastName.trim()) {
        errors.lastName = 'نام خانوادگی را وارد کنید';
      }
      // if (!values.username) {
      //   errors.username = 'نام کاربری را وارد کنید';
      // }
      // else if (!validateNationalID(values.username)) {
      //   errors.username = 'لطفا یک نام کاربری معتبر وارد کنید';
      // }
      if (!values.nationalID) {
        errors.nationalID = 'کد ملی را وارد کنید';
      } else if (!validateNationalID(values.nationalID)) {
        errors.nationalID = 'لطفا یک کد ملی معتبر وارد کنید';
      }
      // else if (
      //   !/(^0?9[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/.test(values.phone)
      // ) {
      //   errors.phone = "شماره موبایل وارد شده اشتباه است";
      // }

      return errors;
    },
    onSubmit: (values) => {
      setLoading(true);
      const formDataGenerator = () => {
        const formData = new FormData();
        formData.append(
          'fullName',
          formikSignUpAgent.values.firstName.trim() + '_' + formikSignUpAgent.values.lastName.trim(),
        );
        formData.append('nationalId', formikSignUpAgent.values.nationalID.trim());

        return formData;
      };
      signUpAgent(formDataGenerator())
        .then((res) => {
          if (res.status === 'success') {
            ToastSuccess({ content: 'ثبت نام مشاور با موفقیت انجام شد' });
          } else {
            ToastError({
              content: 'مشکلی در ثبت نام مشاور پیش آمده، مجددا تلاش کنید',
            });
          }
        })
        .catch((e) => {
          ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید' });
        })
        .finally((e) => {
          setLoading(false);
          refetch();
        });
    },
  });

  return (
    <>
      {!signUp ? (
        <div className="flex flex-col w-full h-full items-center justify-center gap-16">
          <h3 className="text-lg md:text-2xl 2xl:text-3xl font-bold whitespace-nowrap text-text-hard dark:text-white">
            برای ثبت نام اطلاعات زیر را تکمیل نمایید .
          </h3>
          <form
            onSubmit={formikSignUpAgent.handleSubmit}
            className="grid grid-cols-2 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-12 w-full max-w-[550px] place-items-start"
          >
            <div className="flex flex-col relative gap-1 col-span-1 w-full">
              <InputText
                name="firstName"
                title="نام"
                placeholder="برای مثال : امیر رضا"
                value={formikSignUpAgent.values.firstName}
                errors={formikSignUpAgent.errors.firstName}
                touched={formikSignUpAgent.touched.firstName}
                handleBlur={formikSignUpAgent.handleBlur}
                handleChange={formikSignUpAgent.handleChange}
              />
            </div>
            <div className="flex flex-col relative gap-1 col-span-1 w-full">
              <InputText
                name="lastName"
                title="نام خانوادگی"
                placeholder="برای مثال : خسروی"
                value={formikSignUpAgent.values.lastName}
                errors={formikSignUpAgent.errors.lastName}
                touched={formikSignUpAgent.touched.lastName}
                handleBlur={formikSignUpAgent.handleBlur}
                handleChange={formikSignUpAgent.handleChange}
              />
            </div>
            {/* <div className="flex flex-col relative gap-1 col-span-2 w-full">
              <InputText
                name="username"
                title="نام کاربری"
                placeholder="مثال : amirreza"
                value={formikSignUpAgent.values.username}
                errors={formikSignUpAgent.errors.username}
                touched={formikSignUpAgent.touched.username}
                handleBlur={formikSignUpAgent.handleBlur}
                handleChange={formikSignUpAgent.handleChange}
              />
            </div> */}
            <div className="flex flex-col relative gap-1 col-span-2 w-full">
              <InputNumber
                // disabled={true}
                name="nationalID"
                title="کد ملی"
                // required={true}
                placeholder="کد ملی را وارد کنید"
                value={formikSignUpAgent.values.nationalID}
                errors={formikSignUpAgent.errors.nationalID}
                touched={formikSignUpAgent.touched.nationalID}
                handleBlur={formikSignUpAgent.handleBlur}
                handleChange={formikSignUpAgent.handleChange}
              />
            </div>
            <div className="sm:col-span-1 col-span-2 max-sm:w-full">
              <button disabled={loading} type="submit" className="btn btn-primary max-sm:w-full">
                {loading ? <LoaderBtn /> : 'تایید و ثبت نام'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <CompleteSignup role="مشاور" />
      )}
    </>
  );
}
